export default {"src":"/_next/static/media/deco_checkout_questionmark.6dc91ae9.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};